export default __webpack_public_path__ + "static/media/product-image-4.473c7ffb.jpg";